module.exports = __webpack_public_path__ + "static/media/def2.0c3c69e0.jpg";